import { render } from "./SideBarAsideFix.vue?vue&type=template&id=3f993952"
import script from "./SideBarAsideFix.vue?vue&type=script&lang=js"
export * from "./SideBarAsideFix.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abayomi/Documents/dev/microservice-2/contact-mgt-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__